import { WPSClient, getWidgetProps } from 'DVWebNodeUtils';
import  { RetailNavWidget } from './components/RetailNavWidget'
import transformNav from './transforms/RetailNav';
import { RetailNavProps } from './types'
import { prepareRetailNavResponseFallback } from './mocks/RetailNavFallback'
import '../../../../shared/global.module.scss';

require('./index.module.scss');
// Client-side only Javascript
if (!global.__SERVER__) {
    require('./scripts/retail-nav')
}

const getProps: getWidgetProps<RetailNavProps> =
    global.__SERVER__ === true
        ? async ({ context }, api) => {
              const isSignedIn = Boolean(context.customerID)
              const wpsClient = new WPSClient(api)
                const [navResponse, getProfilesResponse] = await Promise.all([
                    wpsClient.Navigation({ context }).catch(_ => {
                        /* Return static fallback */
                        api.logger.count('DVWebNodeNav-RetailNavFallback', 1, true)
                        return prepareRetailNavResponseFallback(context.marketplaceID)}),
                    isSignedIn && wpsClient.GetProfiles({ withAdditionalData: true, context })
                    ])
                return transformNav(
                    context,
                    navResponse,
                    {isCerberusEnabled: isSignedIn,
                        data: getProfilesResponse }
                )
          }
        : undefined;

export const RetailNav = {
    name: 'retail-nav',
    getProps,
    Component: RetailNavWidget
};
